<template>
	<div class="user-rewards-page">
		<div class="user-rewards-content desktop-center">
			<!-- <div class="savings-banner-container">
				<div class="savings-banner">
					<div class="saving-banner-title">2ndKitchen Savings</div>
					<div class="saving-banner-amount">$67.00</div>
					<div class="saving-banner-subtitle"> You've saved $X in delivery fees by ordering through your community's 2ndKitchen portal</div>
				</div>
				<div class="sk-widget user-rewards-tabs">
					<div class="selected">Offers</div>
					<div>History</div>
				</div>
			</div> -->
			<div class="user-perks-container">
				<LoyaltyWidget
					v-if="loyaltyCampaign"
					:campaign="loyaltyCampaign"
				/>
				<ReferralWidget
					v-if="referralCampaignProgress"
					:progress="referralCampaignProgress"
					:coupon="userReferralCoupon"
				/>
				<div class="sk-widget sk-widget-perk" v-if="showSmsPromotion">
					<img
						class="perk-image"
						src="/images/2k-sms-optin-banner.png"
						alt="Referral Perk Image"
					/>
					<div>
						<h2>5% Off All Future Orders</h2>
						<div class="subtitle">
							Subscribe to receive daily menu SMS updates!
						</div>
						<button
							class="button button-primary button-auto"
							@click="smsOptInClicked"
						>
							<i class="sk-icon-bell-on-solid"></i>
							Subscribe
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.user-rewards-page {
	background: var(--sk-grey-bg);
	overflow-y: auto;
	padding-top: 20px;
}

.user-rewards-content {
	padding: 0 10px;
}

.desktop-center {
	max-width: 700px !important;
}

.user-perks-container {
	margin: 0 25px;
}

.savings-banner {
	background: var(--gR-base-90);
	border-radius: 5px;
	padding: 20px 20px 48px 20px;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: space-between;
	height: 200px;
}

.savings-banner-container {
	margin-bottom: 30px;
}

.saving-banner-title,
.saving-banner-subtitle,
.saving-banner-amount {
	color: var(--gR-white);
}

.saving-banner-title,
.saving-banner-amount {
	font-weight: 600;
}

.saving-banner-title {
	font-size: 16px;
}

.saving-banner-amount {
	font-size: 36px;
}

.saving-banner-subtitle {
	font-size: 12px;
}

.user-rewards-tabs {
	margin: 0 25px;
	width: calc(100% - 50px);
	margin-top: -30px;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
}

.user-rewards-tabs div {
	color: var(--sk-grey2);
	font-size: 14px;
}

.user-rewards-tabs .selected {
	color: var(--gR-base-80);
	font-weight: 600;
}

.sk-widget-perk .button-auto {
	font-weight: 400;
	font-size: 10px;
	padding: 5px 20px;
}

.sk-widget-perk .button-auto i {
	font-size: 10px;
	margin-right: 10px;
}
</style>

<script>
import loaderMixin from "@/mixins/loader-mixin"
import userPerksMixin from "@/mixins/user-perks-mixin"
import LoyaltyWidget from "@/components/common/LoyaltyWidget.vue"
import ReferralWidget from "@/components/common/ReferralWidget.vue"
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import { NotificationType } from "@/enums/NotificationType"

export default {
	name: "UserRewards",
	mixins: [loaderMixin, userPerksMixin],
	components: {
		LoyaltyWidget,
		ReferralWidget
	},
	methods: {
		smsOptInClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "SMS Promotion Clicked"
			})
			this.$emit("toggleLoader", true)
			this.$store
				.dispatch("updateUser", {
					smsOptIn: 1
				})
				.then(() => {
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message:
							"You're now subscribed to daily menu SMS updates!",
						type: NotificationType.SUCCESS
					})
				})
				.catch((e) => {
					this.bugsnag.notify(
						"Failed to opt into SMS updates",
						(event) => {
							event.addMetadata("error", {
								error: e
							})
						}
					)
					eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
						message: "An error occurred, please try again.",
						type: NotificationType.ERROR
					})
				})
				.finally(() => {
					this.$emit("toggleLoader", false)
				})
		}
	},
	mounted: function () {
		this.getUserPerks()
	}
}
</script>